export const SUPPORTED_LANGUAGES = [
  {name: 'English', code: 'en-US'},
  {name: 'Español', code: 'es-US'},
  {name: 'Deutsch', code: 'de-DE'},
  {name: 'Français', code: 'fr-FR'},
  {name: 'हिन्दी', code: 'hi-IN'},
  {name: 'Português', code: 'pt-BR'},
  {name: 'العربية', code: 'ar-XA'},
  {name: 'Bahasa Indonesia', code: 'id-ID'},
  {name: 'Italiano', code: 'it-IT'},
  {name: '日本語', code: 'ja-JP'},
  {name: 'Türkçe', code: 'tr-TR'},
  {name: 'Tiếng Việt', code: 'vi-VN'},
  {name: 'বাংলা', code: 'bn-IN'},
  {name: 'ગુજરાતી', code: 'gu-IN'},
  {name: 'ಕನ್ನಡ', code: 'kn-IN'},
  {name: 'മലയാളം', code: 'ml-IN'},
  {name: 'मराठी', code: 'mr-IN'},
  {name: 'தமிழ்', code: 'ta-IN'},
  {name: 'తెలుగు', code: 'te-IN'},
  {name: 'Nederlands', code: 'nl-NL'},
  {name: '한국어', code: 'ko-KR'},
  {name: '官话', code: 'cmn-CN'},
  {name: 'Polski', code: 'pl-PL'},
  {name: 'Русский', code: 'ru-RU'},
  {name: 'Kiswahili', code: 'sw-KE'},
  {name: 'ไทย', code: 'th-TH'},
  {name: 'اردو', code: 'ur-IN'},
  {name: 'Українська', code: 'uk-UA'},
] as const // Use 'as const' for better type safety

// Derive the LanguageCode type from the array
export type LanguageCode = typeof SUPPORTED_LANGUAGES[number]['code']
export type LanguageName = typeof SUPPORTED_LANGUAGES[number]['name']

// Utility function to check if a code is valid
const validCodes = new Set(SUPPORTED_LANGUAGES.map((lang) => lang.code))
export const isValidLanguageCode = (
  code: string | null
): code is LanguageCode => !!code && validCodes.has(code as LanguageCode)

// Helper to get language name from code
export const getLanguageName = (code: LanguageCode): LanguageName => {
  const lang = SUPPORTED_LANGUAGES.find((l) => l.code === code)
  return lang ? lang.name : 'English'
}
